export const USER_TYPES = {
  lead_coach: 'College Coach',
  head_coach: 'Head Counselor',
  admin: 'Admin',
  student: 'Student',
  parent: 'Guardian',
  fa_coach: 'Financial Aid Counselor'
};

export const ROLES = {
  LC: 'lead_coach',
  HC: 'head_coach',
  STUDENT: 'student',
  PARENT: 'parent',
  ADMIN: 'admin',
  FA: 'fa_coach'
}
